module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ac-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "ac-modal"
  }, [_c('div', {
    staticClass: "ac-head"
  }, [_c('div', [_c('div', {
    staticClass: "ac-title"
  }, [_vm._v("All comments")]), _vm._v(" "), _c('div', {
    staticClass: "ac-subtitle"
  }, [_vm._v(_vm._s(_vm.openCount) + " open · " + _vm._s(_vm.resolvedCount) + " resolved")])]), _vm._v(" "), _c('button', {
    staticClass: "ac-close",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ac-filters"
  }, [_c('button', {
    staticClass: "ac-filter",
    class: {
      active: _vm.filter === 'open'
    },
    on: {
      "click": function($event) {
        _vm.filter = 'open'
      }
    }
  }, [_vm._v("Open")]), _vm._v(" "), _c('button', {
    staticClass: "ac-filter",
    class: {
      active: _vm.filter === 'resolved'
    },
    on: {
      "click": function($event) {
        _vm.filter = 'resolved'
      }
    }
  }, [_vm._v("Resolved")]), _vm._v(" "), _c('button', {
    staticClass: "ac-filter",
    class: {
      active: _vm.filter === 'all'
    },
    on: {
      "click": function($event) {
        _vm.filter = 'all'
      }
    }
  }, [_vm._v("All")])]), _vm._v(" "), _c('div', {
    staticClass: "ac-body"
  }, [(!_vm.groups.length) ? _c('div', {
    staticClass: "ac-empty"
  }, [_vm._v("\n        " + _vm._s(_vm.filter === 'open' ? 'No open comments.' : _vm.filter === 'resolved' ? 'No resolved comments.' : 'No comments yet on this journey.') + "\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('div', {
      key: group.stageName,
      staticClass: "ac-group"
    }, [_c('button', {
      staticClass: "ac-group-head",
      on: {
        "click": function($event) {
          return _vm.$emit('select-stage', group.stageName)
        }
      }
    }, [_vm._v(_vm._s(group.stageName))]), _vm._v(" "), _vm._l((group.comments), function(c) {
      return _c('div', {
        key: c.id,
        staticClass: "ac-item",
        class: {
          resolved: c.resolved
        }
      }, [_c('span', {
        staticClass: "ac-avatar",
        style: ({
          background: _vm.avatarColor(c.author)
        })
      }, [_vm._v(_vm._s(_vm.initials(c.author)))]), _vm._v(" "), _c('div', {
        staticClass: "ac-item-body"
      }, [_c('div', {
        staticClass: "ac-meta"
      }, [_c('span', {
        staticClass: "ac-author"
      }, [_vm._v(_vm._s(c.author))]), _vm._v(" "), _c('span', {
        staticClass: "ac-time"
      }, [_vm._v(_vm._s(_vm.relativeTime(c.createdAt)))])]), _vm._v(" "), _c('div', {
        staticClass: "ac-text"
      }, [_vm._v(_vm._s(c.text))]), _vm._v(" "), _c('button', {
        staticClass: "ac-resolve",
        class: {
          done: c.resolved
        },
        on: {
          "click": function($event) {
            return _vm.toggleResolved(c)
          }
        }
      }, [_c('span', {
        staticClass: "ac-resolve-dot"
      }), _vm._v("\n              " + _vm._s(c.resolved ? 'Resolved' : 'Mark resolved') + "\n            ")])])])
    })], 2)
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-473fb51a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/AllCommentsModal.vue
// module id = YYSd
// module chunks = 1